import moment from 'moment'

import {
  CreativeEvent,
  CreativeMigration,
} from '../interfaces/entities/creative'

export const creativeReopens: CreativeEvent[] = [
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-10-09 17:17'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-10-05 18:02'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-09-29 18:13'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-08-20 16:10'),
    user: 'John Doe',
  },
]

export const creativeSent: CreativeEvent[] = [
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-10-09 17:17'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-10-05 18:02'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-09-29 18:13'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-08-20 16:10'),
    user: 'John Doe',
  },
]

export const creativeOutdated: CreativeEvent[] = [
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-10-09 17:17'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-10-05 18:02'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-09-29 18:13'),
    user: 'John Doe',
  },
  {
    type: { name: 'sent', label: 'sent' },
    time: moment('2018-08-20 16:10'),
    user: 'John Doe',
  },
]

export const creativeMigration: CreativeMigration = {
  message: 'Lorem ipsum doloret sumit ',
}
